<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [style]="{width: '600px'}"
  (onHide)="closeModalAddFolder()">
  <p-header>
    @if (typeOfEvent() === 'mod') {
    <span class="font-normal">Modifica {{levelLabels[currentLevel()]}}</span> {{ nodeToModify()?.sigla }}
    }
    @else if (typeOfEvent() === 'add' && currentFather() !== posizioneRoot) {
    <span class="font-normal">Aggiungi {{levelLabels[currentLevel() + 1]}} in {{levelLabels[currentLevel()]}}</span>
    {{nodeToModify()?.sigla }}
    }
    @else {
    <span>Aggiungi {{levelLabels[currentLevel()]}}</span>
    }
  </p-header>
  <form [formGroup]="folderForm">
    <div class="card">
      <div class="field">
        <label for="name">Numero*</label>
        <input id="name" class="w-full" type="text" pInputText formControlName="name">
        @if (folderForm.controls.name.hasError('existing')) {
        <small class="p-error">Il numero esiste già</small>
        }
        @if (folderForm.controls.name.dirty && folderForm.controls.name.hasError('required')) {
        <small class="p-error">Il numero è obbligatorio</small>
        }
      </div>
      <div class="field">
        <label for="descrizione">Descrizione</label>
        <input id="descrizione" class="w-full" type="text" pInputText formControlName="descrizione">
      </div>

      @if (isFascicolo()) {
      <div class="field">
        <label for="classificaId">Classifica</label>
        <p-dropdown
          inputId="classificaId"
          [options]="classifiche"
          optionLabel="nomeClassifica"
          optionValue="classificaId"
          [showClear]="true"
          placeholder="Seleziona la classifica"
          formControlName="classificaId"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
      </div>
      <div class="field">
        <label for="tipologiaFascicolo">Tipologia fascicolo</label>
        <p-dropdown
          inputId="tipologiaFascicolo"
          [options]="tipologiaFascicoloOptions"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="Seleziona la tipologia"
          formControlName="tipologiaFascicolo"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
      </div>
      <div class="field">
        <label for="progressivo">Progressivo</label>
        <input id="progressivo" class="w-full" type="number" min="1" pInputText formControlName="progressivo">
        @if (folderForm.controls.progressivo.hasError('min')) {
        <small class="p-error">Il progressivo deve essere maggiore di zero</small>
        }
      </div>
      <div class="field">
        <label for="posizioneFisica">Posizione fisica</label>
        <input id="posizioneFisica" class="w-full" type="text" pInputText formControlName="posizioneFisica">
      </div>
      <div class="field">
        <label for="paroleChiave">Parole chiave</label>
        <p-chips inputId="paroleChiave" formControlName="paroleChiave" separator="," [addOnBlur]="true"></p-chips>
        @if (folderForm.controls.paroleChiave.hasError('maxItems')) {
        <small class="p-error">Massimo 5 parole chiave</small>
        }
        @if (folderForm.controls.paroleChiave.hasError('maxLength')) {
        <small class="p-error">Ogni parola chiave deve avere massimo 255 caratteri</small>
        }
      </div>
      <div class="field">
        <label for="dataApertura">Data apertura</label>
        <p-calendar [maxDate]="today" dateFormat="dd/mm/yy" styleClass="w-full" [readonlyInput]="false"
          formControlName="dataApertura" appendTo="body">
        </p-calendar>
        @if (folderForm.controls.dataApertura.hasError('required')) {
        <small class="p-error">La data di apertura è obbligatoria</small>
        }
      </div>
      <div class="field">
        <label for="dataChiusura">Data chiusura</label>
        <p-calendar [minDate]="folderForm.getRawValue().dataApertura" dateFormat="dd/mm/yy" styleClass="w-full"
          [readonlyInput]="false" formControlName="dataChiusura" appendTo="body">
        </p-calendar>
      </div>
      <div class="field">
        <label for="dataScadenza">Data scadenza</label>
        <p-calendar [minDate]="folderForm.getRawValue().dataApertura" dateFormat="dd/mm/yy" styleClass="w-full"
          [readonlyInput]="false" formControlName="dataScadenza" appendTo="body">
        </p-calendar>
      </div>
      }

      <div class="field">
        <label for="note">Note</label>
        <input id="note" class="w-full" type="text" pInputText formControlName="note">
      </div>
    </div>

  </form>
  <p-footer>
    <button pButton type="button" label="Annulla" title="Annulla" class="p-button-secondary"
      (click)="closeModalAddFolder()"></button>
    <button pButton type="button" [label]="typeOfEvent() === 'mod' ? 'Modifica' : 'Aggiungi'"
      title="{{typeOfEvent() === 'mod' ? 'Modifica' : 'Aggiungi'}}" (click)="addFolder()"
      [disabled]="folderForm.invalid"></button>
  </p-footer>
</p-dialog>
